import React from 'react';
import * as Sentry from '@sentry/react';


export default class GlobalErrorBoundaryAppLevel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eventId: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true });
        Sentry.withScope(scope => {
            scope.setExtras(errorInfo);
            const eventId = Sentry.captureException(error);
            this.setState({ eventId });
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={'error-boundary-app-level'}>
                    <div>
                        An unexpected error has caused a fatal crash. Our team has been notified and will look further into the problem.
                        <br />
                        Please try again later or report a bug if the issue persists.
                    </div>
                    <a href="./" className="btn-blue">
                        Return home
                    </a>
                </div>
            );
        }
        return this.props.children;
    }
}
